import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { setLocation } from "../../../redux/slices/moviesSlice";

const LocationChooser = ({ locations = [] }) => {
  /* #region  Redux */
  const _location = useSelector((state) => state.moviesReducer.location);
  const dispatch = useDispatch();
  /* #endregion */
  return (
    <Stack direction="row" spacing={1} alignItems="center" flexGrow={1}>
      <Typography variant="body1"> Current location:</Typography>
      <FormControl size="small">
        <InputLabel id="locationLabel">Location</InputLabel>
        <Select
          sx={{ minWidth: "10vw" }}
          labelId="locationLabel"
          label="Location"
          value={_location}
          onChange={(event) => dispatch(setLocation(event.target.value))}
        >
          {locations.map((location) => (
            <MenuItem value={location} key={location}>
              {location}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Stack>
  );
};
export default LocationChooser;
